import {
  REGISTER_USER,
  REGISTER_USER_CONFIRMATION,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  GET_PROVIDERS,
  REGISTER_PROVIDERS,
  GET_TERMS,
  REGISTER_TERMS,
  RESET_VALUES,
} from "./actionTypes"

export const registerUser = user => {
  return {
    type: REGISTER_USER,
    payload: { user },
  }
}

export const registerUserConfirmation = (user, confirmation, client, history) => {
  return {
    type: REGISTER_USER_CONFIRMATION,
    payload: { user, confirmation, client, history },
  }
}

export const getProviders = (json) => {
  return {
    type: GET_PROVIDERS,
    payload: { json },
  }
}

export const getTerms = () => {
  return {
    type: GET_TERMS,
    payload: {},
  }
}

export const registerUserSuccessful = user => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  }
}

export const registerUserFailed = user => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  }
}

export const registerProviders = list => {
  return {
    type: REGISTER_PROVIDERS,
    payload: list,
  }
}

export const registerTerms = obj => {
  return {
    type: REGISTER_TERMS,
    payload: obj,
  }
}

export const resetValues = () => {
  return {
    type: RESET_VALUES,
    payload: {},
  }
}
